import * as Yup from "yup";

import { Strings } from "@app/constants";

export const addNewCategorySchema = Yup.object()
  .shape({
    name: Yup.string().required(
      Strings.validation.fieldRequired(Strings.dashboard.name)
    ),
    parentCategory: Yup.string().required(
      Strings.validation.selectionRequired(Strings.common.parentCategory)
    ),
  })
  .required();
export const addNewParentCategorySchema = Yup.object()
  .shape({
    name: Yup.string().required(
      Strings.validation.fieldRequired(Strings.dashboard.name)
    ),
  })
  .required();
